import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { PaymentStore } from 'src/app/core/stores/payment.store';
import { RestaurantStore } from 'src/app/core/stores/restaurant.store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Restaurant } from 'src/app/core/models/restaurant.model';
import { CustomerGiftCard } from 'src/app/core/models/gift-card.model';
import { Clipboard as WebClipboard } from '@angular/cdk/clipboard';
import { Platform } from '@ionic/angular';
import { BehaviorSubject,timer } from 'rxjs';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-gift-cards',
  templateUrl: './gift-cards.component.html',
  styleUrls: ['./gift-cards.component.scss'],
})
export class GiftCardsComponent implements OnInit, OnDestroy {
  @Input() currencySign = '$';

  private destroyed$ = new Subject<void>();
  private clicked$: BehaviorSubject<string> = new BehaviorSubject<string>(null); 

  public giftCards:CustomerGiftCard[];
  public locationId: string;
  public restaurant: Restaurant;

  constructor(
    public paymentStore:PaymentStore,
    public restaurantStore:RestaurantStore,
    private route: ActivatedRoute,
    private webClipboard: WebClipboard,
    public platform: Platform,
  ) { }

  copyToClipboard(text: string) {
      this.webClipboard.copy(text);
      this.clicked$.next(text);
      setTimeout(() => {
        this.clicked$.next('');
        }, 1000);
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if(params.locationId){
        this.locationId = params.locationId
        this.getRestaurant();
      }
    })

    this.paymentStore.customer$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if(this.paymentStore.customer.giftCards){
          this.giftCards = this.paymentStore.customer.giftCards
        }
      })
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }

  private getRestaurant() {
    this.restaurantStore
      .getRestaurantById(this.locationId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((restaurant) => {
        if (restaurant) {
          this.restaurant = restaurant;
        }
      })
  }

  private getFormattedPrice(price: string | number): string {
    return (+price).toFixed(2);
  }

}
